export default __webpack_public_path__ + "static/media/inbox_en.af17221b.png";